import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../api/useApiClient';
import { useAuthToken } from '../../hooks/useAuthToken';
import { fetchUserProfile, fetchUserPermissions } from '../../api/user';

export const useUserProfile = (userId: string) => {
  const client = useApiClient();
  const { hasToken } = useAuthToken();
  return useQuery({
    queryKey: ['user', userId, 'profile'],
    queryFn: () => fetchUserProfile(client, userId),
    enabled: hasToken && !!userId,
  });
};

export const useUserPermissions = () => {
  const client = useApiClient();
  const { hasToken } = useAuthToken();
  return useQuery({
    queryKey: ['user', 'permissions'],
    queryFn: () => fetchUserPermissions(client),
    enabled: hasToken,
  });
};
